import styled from 'styled-components';
export const DropAreaContainer = styled.div `
  backgroundColor: red;

  > div {
    input[type="file"] {
      width: 100%;
      z-index: 10000;
    }
  }
`;
//# sourceMappingURL=dropAreaContainer.js.map